import { useConfirm } from "../hooks/useConfirm";
import { AlertPanel } from "./AlertPanel";
import { Drawer } from "./Drawer";
import { useRoute } from "../contexts/RouterContext";
import type { FiredAlert } from "../types/alerts";

interface AlertDrawerProps {
  open: boolean;
  alerts: FiredAlert[];
  onAcknowledge: (id: string) => void;
  onClear: () => void;
  onClose: () => void;
}

export function AlertDrawer({
  open,
  alerts,
  onAcknowledge,
  onClear,
  onClose,
}: AlertDrawerProps) {
  const { confirm, dialog } = useConfirm();
  const { navigate } = useRoute();


  const headerActions = (
    <>
      {alerts.length > 0 && (
        <button
          className="alert-drawer__manage"
          onClick={async () => {
            if (
              await confirm({
                title: "Clear alert history?",
                message: `${alerts.length} alert${alerts.length === 1 ? "" : "s"} will be removed from this list.`,
                confirmLabel: "Clear",
                danger: true,
              })
            ) {
              onClear();
            }
          }}
          type="button"
        >
          Clear
        </button>
      )}
      <button
        className="alert-drawer__manage"
        onClick={() => {
          onClose();
          navigate({ view: "settings", tab: "alerts" });
        }}
        type="button"
      >
        Manage Rules
      </button>
    </>
  );

  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={`Alerts${alerts.length > 0 ? ` (${alerts.length})` : ""}`}
      closeLabel="Close alert drawer"
      headerActions={headerActions}
    >
      <AlertPanel alerts={alerts} onAcknowledge={onAcknowledge} />
      {dialog}
    </Drawer>
  );
}
